module.exports = function () {        
    if ($('.large-carousel-module').length === 0) {
        return;
    }

    var stopAutoPlay = function (swiper, $swiperPagination) {        
        $swiperPagination.removeClass('swiper-pagination--autoplay-active');        
    }

    var startAutoPlay = function (swiper, $swiperPagination) {          
        $swiperPagination.addClass('swiper-pagination--autoplay-active');
    }

    var slideChangeTransitionEndEvent = function (swiper) {        
        var $activeSlide = $(swiper.el).find('.swiper-slide-active');        
        var activeSlideIndex = $activeSlide.data('swiperSlideIndex');
        $(swiper.el).closest('.large-carousel-module').find('.swiper-pagination-bullet-progress-bar').each(function (index) {
            if (index < activeSlideIndex) {
                this.style.setProperty("--progress", 1)
            }
            else {
                this.style.setProperty("--progress", 0)
            }
        });        
    }
    $('.large-carousel-module').each(function () {        
        var $swiperPagination = $(this).find(".swiper-pagination");        

        var largeCarouselSwiper = new Swiper('.swiper', {                        
            autoplay: {
                delay: 6000,
                pauseOnMouseEnter: true,
                disableOnInteraction: true,
            },
            direction: 'horizontal',
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            on: {
                autoplayStart(swiper) {
                    startAutoPlay(swiper, $swiperPagination);

                },
                autoplayStop(swiper) {
                    stopAutoPlay(swiper, $swiperPagination);

                },
                autoplayTimeLeft(s, time, progress) {
                    if (progress < 0) {                        
                        $swiperPagination.find('.swiper-pagination-bullet-active .swiper-pagination-bullet-progress-bar')[0].style.setProperty("--progress", 1);
                    }
                    else if (progress > 1)
                    {
                        $swiperPagination.find('.swiper-pagination-bullet-active .swiper-pagination-bullet-progress-bar')[0].style.setProperty("--progress", 0);
                    }
                    else {
                        $swiperPagination.find('.swiper-pagination-bullet-active .swiper-pagination-bullet-progress-bar')[0].style.setProperty("--progress", 1 - progress);
                    }                    
                },
                slideChangeTransitionStart(swiper) {
                    slideChangeTransitionEndEvent(swiper);
                },                
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return '<div class="' + className + '"><div class="swiper-pagination-bullet-progress-bar"></div></div>'
                }
            },
        })
    });

    var syncAutoplayWithScreenSize = function () {
        if (!ICF.Utils.Breakpoints.IsAtLeastDesktopSm()) {
            $('.large-carousel-module .swiper').each(function () {
                this.swiper.autoplay.stop();
            });
        }
        else {
            $('.large-carousel-module .swiper').each(function () {
                this.swiper.autoplay.start();
            });
        }
    };

    syncAutoplayWithScreenSize()

    $(window).resize(function () {
        syncAutoplayWithScreenSize();
    });
};